import axios from 'axios';

export default {
	init(formType) {
		return axios.get('/eszigno/rest/eakta/init', {
			params: {
				formType
			}
		});
	},
	submitForm(formData) {
		return axios.post('/eszigno/rest/eakta/form', formData);
	},
	generateCaptcha() {
		return axios.get('/eszigno/rest/eakta/captcha');
	},
	submitFile(benyujtId, file, formType) {
		const bodyFormData = new FormData();
		bodyFormData.append('file', file);
		return axios({
			method: 'post',
			url: `/eszigno/rest/eakta/file/${formType}`,
			data: bodyFormData,
			params: {
				benyujtId
			}
		});
	},
	finalize(id, formType) {
		return axios.post(`/eszigno/rest/eakta/finish/${id}/${formType}`);
	}
};
